/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Alert, Text, Button } from 'sarsaparilla';
import { GUEST_CHECKOUT_HELP_LINK } from '../../constants/index.js';

export function GuestCheckoutNotice() {
    return (
        <div data-component="GuestCheckoutNotice">
            <Alert type="info">
                <Text size="sm">
                    Guest checkout is available at this location for same day
                    reservations.{' '}
                    <Button
                        appearance="link"
                        href={GUEST_CHECKOUT_HELP_LINK}
                        aria-label="Click here to learn more about guest checkout reservations"
                    >
                        Learn more
                    </Button>
                </Text>
            </Alert>
        </div>
    );
}
